import colors from './colors'
import images from './images'
import texts from './texts'
import styles from './styles'
import svgs from './svgs.js'

export const Svgs = svgs
export const Colors = colors
export const Images = images
export const Texts = texts
export const Styles = styles
